import React from "react"
import { Button } from "../../components/Button"
import { ModalBody, ModalHeader, ModalPanel } from "../../components/Modal"
import "./styles.scss"
import { useRef } from "react"
import { useEffect } from "react"
import { isMobile } from "react-device-detect"
import { FaTable } from "react-icons/fa"
import { Table } from "antd"
import moment from "moment"
import { Input, SelectInput } from "../../components/Form"
import { PickerWithType } from "../../components/DatePicker"
import { BsFiletypeXlsx } from "react-icons/bs"
import { TagList } from "../../components/TagSelect"
import "moment/locale/pt-br"
import { ActionPlanAdd, ActionPlanCommentAdd, ActionPlanFilter, columsActionTable } from "../ActionPlanScreen"
import { TaskTableContainer } from "../../container/ActionPlanTaskTableContainer"
import { statusOptions } from "../../container/ActionPlanContainer"
import { IoFilterOutline } from "react-icons/io5"
import { RiEdit2Fill } from "react-icons/ri"
import { HiOutlinePencil } from "react-icons/hi"
import { MdDelete } from "react-icons/md"
import ModalAlert from "../../components/ModalAlert"
moment.locale("pt-br")

const ActionTableScreen = ({
  openModal,
  modalIsOpen,
  closeModal,
  selectedUsers,
  selectedProjects,
  data,
  uniqueEmails,
  filter,
  changeFilter,
  exportPlan,
  tagPossibility,
  setTagPossibility,
}) => {
  const selectEndRef = useRef(null)

  const scrollToBottom = () => {
    const scroll = selectEndRef.current?.scrollHeight - selectEndRef.current?.clientHeight
    selectEndRef.current?.scrollTo(0, scroll)
  }

  useEffect(() => {
    if (selectedProjects && selectedProjects?.length > 10) {
      scrollToBottom()
    }
  }, [selectedProjects])

  return (
    <>
      {selectedUsers && selectedUsers?.length > 0 && (
        <Button
          hiddenText
          hasIcon={<FaTable size={16} />}
          label="Plano de ação"
          handleClick={() => openModal()}
          color={isMobile ? "new_green" : "orange"}
        />
      )}
      {modalIsOpen && (
        <ModalPanel modalIsOpen={modalIsOpen}>
          <ModalHeader closeModal={() => closeModal()} title={"Plano de ação"} />
          <ModalBody>
            <div className={"card-tag-list actions"}>
              <TaskTableContainer
                {...{
                  data,
                  tagPossibility,
                  uniqueEmails,
                  setTagPossibility,
                  showActions: false,
                  changeFilter,
                  filter,
                  exportPlan,
                }}
              />
            </div>
          </ModalBody>
        </ModalPanel>
      )}
    </>
  )
}

export default ActionTableScreen

let locale = {
  emptyText: "Não há dados",
}

export const TaskTable = ({
  handleCompleteAction,
  handleOpenModalComment,
  handleCloseModalComment,
  changeTag,
  tagPossibility,
  changeFilter,
  filter,
  uniqueEmails,
  exportPlan,
  data,
  isAssistanceScreen = false,
  loadingActionSave,
  loadingActionPlan,
  handleModalOpenEdit,
  handleDeleteAction,
  handleUpdateAction,
  modalOpen,
  setModalOpen,
  values,
  onChangeValues,
  showActions = true,
  formSteps,
  indicatorTabsOptions,
  indicators,
  handleActiveIndicator,
  technicalList,
  setModalFilterIsOpen,
  modalFilterIsOpen,
  userId,
  openModalComment,
  handleCreateComment,
  handleEditComment,
  handleDeleteComment,
  handleUpdateComment,
  commentEdit,
  loadingSaveComments,
  projects
}) => {

  return (
    <>
      <div className="plan-action-header">
        {!isAssistanceScreen && (
          <>
            <div className="header-period">
              {/* <span>Período</span> */}
              <Input
                onChange={(e) => changeFilter("search", e.target.value)}
                value={filter?.search}
                placeholder={"Pesquise pelo titulo ou pelo nome do produtor"}
              />
            </div>
          </>
        )}

        <div className="export-filter">
          {exportPlan && !isAssistanceScreen && (
            <Button
              hiddenText
              hasIcon={<BsFiletypeXlsx size={16} />}
              label="Exportar"
              handleClick={exportPlan}
              color={isMobile ? "new_green" : "orange"}
            />
          )}

          {!isAssistanceScreen && (
            <div className="header-period-filter">
              <div className="filter-button-container" onClick={() => setModalFilterIsOpen(true)}>
                <IoFilterOutline className="icon-filter" />
                <text className="text-filter">Filtrar</text>
              </div>
            </div>
          )}
        </div>
      </div>
      <Table
        locale={locale}
        columns={columsActionTable(
          handleCompleteAction,
          handleOpenModalComment,
          handleDeleteAction,
          changeTag,
          handleModalOpenEdit,
          tagPossibility,
          showActions,
          userId,
        )}
        dataSource={data}
        rowKey="actionId"
        loading={loadingActionPlan}
        pagination={{ showSizeChanger: !isAssistanceScreen }}
        expandable={{
          expandedRowRender: (record) => (
            <div className="block5w2h-section">
              <div className="content-table">
                <div className="content-block5w2h">
                  <span className="content-block5w2h__title block-title">Indicador Associado</span>
                  <div className="separator"></div>
                  <p className="content-block5w2h__info block-content">
                    {record.indicator || "Não informado"}
                  </p>
                </div>
                <div className="content-block5w2h">
                  <span className="content-block5w2h__title block-title">Onde será realizada a ação</span>
                  <div className="separator"></div>
                  <p className="content-block5w2h__info block-content">
                    {record.location || "Não informado"}
                  </p>
                </div>
                <div className="content-block5w2h">
                  <span className="content-block5w2h__title block-title">Como será realizada a ação?</span>
                  <div className="separator"></div>
                  <p className="content-block5w2h__info block-content">
                    {record.instructions || "Não informado"}
                  </p>
                </div>
                <div className="content-block5w2h">
                  <span className="content-block5w2h__title block-title">Porque realizará a ação?</span>
                  <div className="separator"></div>
                  <p className="content-block5w2h__info block-content">
                    {record.why || "Não informado"}
                  </p>
                </div>
                <div className="content-block5w2h">
                  <span className="content-block5w2h__title block-title">Em quanto tempo será realizada?</span>
                  <div className="separator"></div>
                  <p className="content-block5w2h__info block-content">
                    {isNaN(record.start_at || record.finish_at) ? "Não informado" : moment(record.start_at).utc().format("DD/MM/YYYY") + " - " + moment(record.finish_at).utc().format("DD/MM/YYYY")}
                  </p>
                </div>
                <div className="content-block5w2h">
                  <span className="content-block5w2h__title block-title">Precisa que alguém aprove?</span>
                  <div className="separator"></div>
                  <p className="content-block5w2h__info block-content">
                    {record.reviewerName || "Não informado"}
                  </p>
                </div>
                <div className="content-block5w2h">
                  <span className="content-block5w2h__title block-title">Tags</span>
                  <div className="separator"></div>
                  <div className="block-content">
                    {record.tags && record.tags.length > 0 ? (
                      <TagList
                        handleTagRemove={(value) => changeTag(value, false, record)}
                        tags={record.tags}
                      />
                    ) : "Não informado"}
                  </div>
                </div>
              </div>
              <div className="content-block5w2h comments">
                <span className="content-block5w2h__title comment-section-title">Comentários</span>
                <div className="separator"></div>
                {(() => {
                  let comments = [];

                  try {
                    const parsed = record?.comments ? JSON.parse(record.comments) : [];
                    if (Array.isArray(parsed)) {
                      comments = parsed.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
                    }
                  } catch {
                    comments = [];
                  }

                  return comments.length > 0 ? (
                    comments.map((comment) => (
                      <div className="comment-section">
                        <div className="comment-section-actions">
                          <div className="comment-section-edit">
                            {comment?.id && userId && (
                              <HiOutlinePencil
                                title="Editar"
                                onClick={() => handleEditComment(comment, record?.actionId)}
                              />
                            )}
                          </div>
                          <div className="comment-section-edit">
                            {comment?.id && userId && (
                              <MdDelete
                                title="Excluir"
                                onClick={() =>
                                  ModalAlert.danger({
                                    title: "Excluir Comentário",
                                    text: `Você deseja mesmo excluir este comentário ?`,
                                    confirmLabel: "Sim",
                                    onConfirm: () =>
                                      handleDeleteComment(comment?.id, record?.actionId),
                                  })
                                }
                              />
                            )}
                          </div>
                        </div>
                        <div className="content-block5w2h-comments">
                          <div className="message-content block-content">
                            {comment?.message || "Não informado"}
                          </div>
                          <span className="message-author">
                            <span>
                              <b>Autor:</b>{" "}
                            {comment?.author || "Não informado"}
                            </span>
                            <span>
                              <b>Comentário feito em:</b>{" "}
                            {moment(comment?.date).format("DD/MM/YYYY") || ""}
                            </span>
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="block-content">Não há comentários</p>
                  );
                })()}
              </div>
            </div>
          ),
        }}
      />

      {modalOpen && (
        <ActionPlanAdd
          {...{
            modalOpen,
            modalOpenEdit: true,
            technicalList: [],
            handleUpdateAction,
            onChangeValues,
            values,
            setModalOpen,
            loadingActionSave,
            formSteps,
            indicatorTabsOptions,
            indicators,
            technicalList,
            handleActiveIndicator,
            statusOptions,
          }}
        />
      )}

      {openModalComment && (
        <ActionPlanCommentAdd
          modalOpen={openModalComment}
          handleCloseModalComment={handleCloseModalComment}
          values={values}
          commentEdit={commentEdit}
          onChangeValues={onChangeValues}
          handleCreateComment={handleCreateComment}
          loadingSaveComments={loadingSaveComments}
          handleUpdateComment={handleUpdateComment}
        />
      )}

      {modalFilterIsOpen && (
        <ActionPlanFilter
          {...{
            modalOpen: modalFilterIsOpen,
            setModalOpen: setModalFilterIsOpen,
            changeFilter,
            filter,
            uniqueEmails,
            tagPossibility,
            projects
          }}
        />
      )}

    </>
  )
}
